exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chat-card-log{\n  height:400px\n}\n.chat-card-log .chat-sent-msg{\n  background-color:#f2f4f7 !important\n}", ""]);

// exports
